<template>
  <div class="absolute bottom-0 absolute-center-h z-10 progress-bar">
    <div class="flex items-center relative pb-5">
      <div class="rounded-full border border-grey-100">
        <div
          :class="[progressSection === 'Create account' ? 'bg-white' : 'bg-green-500']"
          class="relative rounded-full border-2 h-5 w-5 cursor-pointer border-green-500"
          @mouseenter="updateSection('Create account')"
          @mouseleave="section = ''"
        >
          <DrIcon
            v-if="progressSection !== 'Create account'"
            svg="checkmark"
            class="absolute absolute-center"
            height="16"
            width="16"
          />
        </div>
      </div>
      <div class="relative z-10 bar-1">
        <div :class="progressSection === 'Create account' ? 'bg-grey-300' : 'bg-green-500'" class="inner-bar" />
      </div>
      <div class="rounded-full border border-grey-100">
        <div
          :class="[
            progressSection !== 'Create account' ? 'border-green-500' : 'border-grey-300',
            progressSection === 'Payment details' ? 'bg-green-500' : 'bg-white',
          ]"
          class="relative rounded-full border-2 h-5 w-5 cursor-pointer"
          @mouseenter="updateSection('Confirm details')"
          @mouseleave="section = ''"
        >
          <DrIcon
            v-if="progressSection === 'Payment details'"
            svg="checkmark"
            class="absolute absolute-center"
            height="16"
            width="16"
          />
        </div>
      </div>
      <div class="relative z-10 bar-2">
        <div :class="progressSection === 'Payment details' ? 'bg-green-500' : 'bg-grey-300'" class="inner-bar" />
      </div>
      <div class="rounded-full border border-grey-100">
        <div
          :class="[progressSection === 'Payment details' ? 'border-green-500' : 'border-grey-300']"
          class="relative rounded-full border-2 h-5 w-5 cursor-pointer bg-white"
          @mouseenter="updateSection('Payment details')"
          @mouseleave="section = ''"
        />
      </div>
      <div
        :class="{ 'opacity-0': !showText }"
        class="absolute bottom-0 absolute-center-h text-center text-3xs leading-normal w-full text-grey-550 bar-text"
      >
        {{ section ? section : progressSection }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showText: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      section: '',
      scrollPosition: 0,
    }
  },
  computed: {
    progressSection () {
      if (this.$route.meta.page && this.$route.meta.page === 15) {
        return 'Create account'
      } else if (this.$route.meta.page && this.$route.meta.page === 16) {
        return 'Confirm details'
      } else if (this.$route.meta.page && this.$route.meta.page === 17) {
        return 'Select date'
      }
      return 'Payment details'
    },
  },
  methods: {
    updateSection (value) {
      this.section = value
    },
  },
}
</script>

<style scoped>
.progress-bar {
  margin-bottom: -33px;
}

.bar-1 {
  margin: -1px -2px 0 -1px;
}

.bar-2 {
  margin: -1px -1px 0 -1px;
}

.inner-bar {
  width: 73px;
  height: 2px;
}

.bar-text {
  transition: opacity 0.3s;
}

.absolute-center-h {
  left: 50%;
  transform: translateX(-50%);
}

.absolute-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
